import { ApiEndpoints } from "../constants/apiEndpoints";
import apiClient from "../utils/apiClient";

class B2bPreOrdersService {
  async placePreOrder(orderData) {
    return await apiClient.post(ApiEndpoints.B2B_PREORDERS, orderData);
  }

  async listPreOrders(params = {}) {
    return await apiClient.get(ApiEndpoints.B2B_PREORDERS, { params });
  }

  async getPreOrder(orderId) {
    return await apiClient.get(`${ApiEndpoints.B2B_PREORDERS}/${orderId}`);
  }

  async uploadDepositReceipt(orderId, formData) {
    return await apiClient.post(
      `${ApiEndpoints.B2B_PREORDERS}/${orderId}/deposit-receipt`,
      formData,
    );
  }

  async uploadBalanceReceipt(orderId, formData) {
    return await apiClient.post(
      `${ApiEndpoints.B2B_PREORDERS}/${orderId}/balance-receipt`,
      formData,
    );
  }

  async getGlobalSettings() {
    return await apiClient.get(ApiEndpoints.PREORDER);
  }

  async getInvoicesForOrder(orderId) {
    return await apiClient.get(
      `${ApiEndpoints.B2B_PREORDERS}/${orderId}/invoices`,
    );
  }

  async downloadPreOrderInvoice(orderId, invoiceId) {
    return await apiClient.get(
      `${ApiEndpoints.B2B_PREORDERS}/${orderId}/invoices/${invoiceId}/download`,
      {
        responseType: "blob",
      },
    );
  }

  async downloadDepositInvoice(orderId) {
    const res = await this.getInvoicesForOrder(orderId);
    const invoices = Array.isArray(res)
      ? res
      : res?.data || res?.invoices || [];
    const invoice = invoices.find(
      (inv) =>
        inv.title?.toLowerCase().includes("deposit") ||
        inv.invoiceNumber?.includes("DEP"),
    );
    if (!invoice) throw new Error("Deposit invoice not found");
    return await this.downloadPreOrderInvoice(orderId, invoice.id);
  }

  async downloadBalanceInvoice(orderId) {
    const res = await this.getInvoicesForOrder(orderId);
    const invoices = Array.isArray(res)
      ? res
      : res?.data || res?.invoices || [];
    const invoice = invoices.find(
      (inv) =>
        inv.title?.toLowerCase().includes("balance") ||
        inv.invoiceNumber?.includes("BAL"),
    );
    if (!invoice) throw new Error("Balance invoice not found");
    return await this.downloadPreOrderInvoice(orderId, invoice.id);
  }

  async cancelPreOrder(orderId, reason = "") {
    return await apiClient.post(
      `${ApiEndpoints.B2B_PREORDERS}/${orderId}/cancel`,
      { reason },
    );
  }
}

const b2bPreOrdersService = new B2bPreOrdersService();
export default b2bPreOrdersService;
export { b2bPreOrdersService };
